import ImageModalOther from '@/assets/images/guide/img_modal_other@2x.png';
import ImageNavWallet2 from '@/assets/images/guide/img_nav_wallet2@2x.png';
import { SpBr } from '@/components/layouts/Modal/Guest/style';

import { Container } from './style';
export interface ChargeOtherProps {}

const ChargeOtherContent: React.FC<ChargeOtherProps> = () => {
  return (
    <Container>
      <h2>その他の決済方法でチャージ</h2>
      <p>
        チャージ画面をスクロールすると、スマホ決済
        <SpBr />
        （PayPay・メルペイ）などのチャージ方法が
        <SpBr />
        選択できます。
      </p>
      <img src={ImageModalOther} alt="modalother" />
      <h3>払戻金からのtoreta+ チャージも可能</h3>
      <p>
        「入金/払戻金 残高」はDMM競輪で投票がで
        <SpBr />
        きる預かり金です。いつでも入金・出金・
        <SpBr />
        toreta+ へチャージが可能です。
      </p>
      <img src={ImageNavWallet2} alt="navwallet2" />
    </Container>
  );
};

export default ChargeOtherContent;
